export default {
  'otp.oldPrice': 'Precio original ',
  'otp.details': 'Detalles de la promoción limitada',
  'otp.effective': 'Vigencia',
  'otp.userTitle': 'Usuarios preferentes',
  'otp.tip':
    'Si ha recargado otros productos de EngageLab pero no el OTP, podrá participar igualmente en esta promoción.',
  'otp.service.dsc': 'Usuarios que utilizan el servicio OTP por primera vez.',
  'otp.event': 'Evento',
  'otp.tip1a':
    'Durante el período promocional, los usuarios que realicen OTP por primera vez tendrán exentos los costes de verificación OTP durante',
  'otp.tip1b': '30 días naturales',
  'otp.tip1c': 'a partir de la fecha de recarga.',
  'otp.notes1': '1. Cada cuenta solo puede participar una vez en esta actividad.',
  'otp.notes2': '2. Una vez completada la recarga, no se admiten reembolsos.',
  'otp.notes2a': 'Contáctenos',
  'otp.notes2b': 'para más información,',
  'otp.notes3':
    '3. EngageLab se reserva el derecho de interpretación final de esta promoción dentro del marco legal.',
  'email.sem.title': 'Limited Time Offer! 500 Free Emails/day for New Users',
  'email.sem.btn': 'Start Now',
};
